import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-job-button',
  templateUrl: './add-job-button.component.html',
  styleUrls: ['./add-job-button.component.css']
})
export class AddJobButtonComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
